import { name, version } from '../package.json';
import { positions } from '@mds/utils-js';

export default {
    autoPosition: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, popover will be positioned based on available window space defaulting to top-center.  Can be overridden by position prop.',
        },
    },
    fixed: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'When a popover is triggered from an element or container set to `position: fixed;`, this prop must be set `true` to ensure proper positioning.',
        },
    },
    headingLevel: {
        type: Number,
        default: 2,
        validator(value) {
            return value >= 1 && value <= 6;
        },
        docs: {
            validation: 'Number in the range `1–6`',
            description: 'Sets the HTML heading level (`<h#>`) used in the header.',
        },
    },
    position: {
        type: String,
        default: null,
        validator: value => positions.indexOf(value) > -1,
        docs: {
            validation:
                'One of `top-center`, `top-right`, `top-left`, `bottom-center`, `bottom-right`, `bottom-left`, `right-center`, `right-bottom`, `left-center`, `left-top`, `left-bottom`.',
            description: 'Sets the position of the popover.',
        },
    },
    title: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'Sets the title of the popover.',
        },
    },
    titleHidden: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, visibly hides the popover’s title. The title is still present for assistive technologies.',
        },
    },
    triggeredBy: {
        type: String,
        required: true,
        docs: {
            validation: 'Required',
            description: 'The `id` of the popover’s trigger element.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
    visible: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'Sets visibility of the popover.',
            support: ['v-model'],
        },
    },
    width: {
        type: String,
        default: '300px',
        validator(value) {
            return ['200px', '300px', '500px'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of `200px`, `300px`, `500px`.',
            description: 'Sets the width of the popover.',
        },
    },
};
